import gql from 'graphql-tag';

const DEVICE_LOCATION = gql`
  query Query($searchQuery: String!) {
    deviceLocationQueries(searchQuery: $searchQuery) {
      latitude
      longitude
      deviceType
      deviceSerialNo
      broker
      hardwareVersion
      isBillable
      version
      status
      simNumber
      networkProvider
      stage
      firmwareVersion
    }
  }
`;

export default DEVICE_LOCATION;
